/* ProtocolRenderer.js */

"use strict";
const _ = require("lodash");
class ProtocolRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("protocol-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        //this._model.on("Protocol", (this._onProtocol = this._onProtocol.bind(this)));
        this._rootElem.addEventListener(
            "click",
            (this._onClickEditIcon = this._onClickEditIcon.bind(this))
        );
    }

    _unregisterListeners() {
        //this._model.removeAllListeners("Protocol");
        this._rootElem.removeEventListener("click", this._onClickEditIcon);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setProtocol(this._model.getValue());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onProtocol(newVal) {
        this._setProtocol(newVal);
    }

    _onClickEditIcon() {
        if (this._model._isCompleted) {
            //clickable?
            return;
        }
        this._model._switchToEditImage();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setProtocol(value) {
        if (value.imageAssociations && !_.isEmpty(value.imageAssociations[this._model._id])) {
            const protocol = value.imageAssociations[this._model._id].protocol;
            this._rootElem.innerHTML = protocol;
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ProtocolRenderer;
